export default __webpack_public_path__ + "static/media/chemex_for_2.c11d535b.png";